<div class="dg-modal-header">
    <h2>Mobile badge request</h2>
    <button type="button" class="close-icon icon-cross_16px" (click)="close()" appTrackClickButton style="border:none;background:transparent;"></button>
</div>

<div class="dg-modal-body">

    <h4 class="header">Request details</h4>

    <div class="note-block">
        <div class="note-block__icon">
            <i class="icon-info"></i>
        </div>
        <div class="note-block__title">
            <span>By clicking the submit button you are applying for a mobile badge in addition to your main badge.</span>
        </div>
    </div>

    <h6 class="header">Select reason for request</h6>

    <div class="tabs align-items-center">
        <ng-container *ngFor="let reason of reasons">
            <button type="button" class="tab"
                 [class.active]="reason.mobileRequestReasonId === selectedReasonId"
                 (click)="selectReasonId(reason.mobileRequestReasonId)">
                <img [src]="reason.icon" alt="{{ reason.mobileRequestReasonName }}">
                <div class="tab__info">
                    <div class="tab__info--caption">{{ reason.mobileRequestReasonName }}</div>
                </div>
            </button>
        </ng-container>
    </div>

    <div class="additional-text">
        <div>
            <label class="option checkbox-label"><input type="checkbox" [(ngModel)]="isConfirmed"><span></span></label>
        </div>
        <span>
            Mobile Badge is currently being rolled out across all Deloitte US offices in waves. Prior to travel to other Deloitte US offices, please visit the Magnet Explore Office Building Access Information to see what might be required for access at the base of the building.
        </span>

    </div>
</div>

<div class="dg-modal-footer">
    <div class="d-flex">
        <button
            id="close"
            type="button"
            class="button secondary"
            appTrackClickButton
            (click)="close()"
        >Cancel
        </button>
        <div class="d-flex">
            <button
                [disabled]="!isSubmitEnabled"
                id="submit"
                type="button"
                class="button primary"
                appTrackClickButton
                (click)="submit()"
            >Submit
            </button>
        </div>
    </div>
</div>
